/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lost_Fluffy_Nils_AgreeInputs */

const en_lost_fluffy_nils_agree = /** @type {(inputs: Lost_Fluffy_Nils_AgreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporting`)
};

const de_lost_fluffy_nils_agree = /** @type {(inputs: Lost_Fluffy_Nils_AgreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berichterstattung`)
};

/**
* | output |
* | --- |
* | "Reporting" |
*
* @param {Lost_Fluffy_Nils_AgreeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lost_fluffy_nils_agree = /** @type {((inputs?: Lost_Fluffy_Nils_AgreeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lost_Fluffy_Nils_AgreeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lost_fluffy_nils_agree(inputs)
	return de_lost_fluffy_nils_agree(inputs)
});